import React, { useState, useEffect } from 'react';

// Helper function to format price
const formatPrice = (price) => {
  // Assuming price is a number, convert it to a string with two decimal places.
  // In a real app, you might want more robust currency formatting.
  return parseFloat(price).toFixed(2);
};

const GalleryPage = () => {
  // State to manage the cart items
  const [cart, setCart] = useState([]);
  const [cartTotal, setCartTotal] = useState('0.00');
  const [totalProducts, setTotalProducts] = useState(0);

  // Function to get cart from localStorage
  const getCartFromLocalStorage = () => {
    try {
      const storedCart = localStorage.getItem('cart');
      return storedCart ? JSON.parse(storedCart) : [];
    } catch (error) {
      console.error("Failed to parse cart from localStorage:", error);
      return [];
    }
  };

  // Function to save cart to localStorage
  const saveCartToLocalStorage = (currentCart) => {
    try {
      localStorage.setItem('cart', JSON.stringify(currentCart));
    } catch (error) {
      console.error("Failed to save cart to localStorage:", error);
    }
  };

  // Effect to load cart on component mount and update totals
  useEffect(() => {
    const initialCart = getCartFromLocalStorage();
    setCart(initialCart);
    updateCartTotals(initialCart);
  }, []); // Empty dependency array means this runs once on mount

  // Effect to update totals whenever the cart state changes
  useEffect(() => {
    saveCartToLocalStorage(cart);
    updateCartTotals(cart);
  }, [cart]); // Runs whenever 'cart' state changes

  // Function to update cart totals
  const updateCartTotals = (currentCart) => {
    let total = 0;
    currentCart.forEach((item) => {
      const priceNum = parseFloat(item.price);
      total += priceNum * item.quantity;
    });
    setCartTotal(total.toFixed(2));
    setTotalProducts(currentCart.length);
  };

  // Function to change item quantity
  const changeQty = (index, delta) => {
    setCart(prevCart => {
      const newCart = [...prevCart];
      newCart[index].quantity += delta;
      if (newCart[index].quantity <= 0) {
        // Remove item if quantity is zero or less
        newCart.splice(index, 1);
      }
      return newCart;
    });
  };

  // Function to remove item from cart
  const removeItem = (index) => {
    setCart(prevCart => {
      const newCart = [...prevCart];
      newCart.splice(index, 1);
      return newCart;
    });
  };

  return (
    <>
      {/* Global styles for the responsive button, extracted from the original HTML */}
      <style>{`
        .responsive-btn {
          display: inline-block;
          padding: 10px 20px;
          background-color: #9D0FA4; /* Primary blue */
          color: #fff;
          font-size: 16px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.2s ease;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .responsive-btn:hover {
          background-color: #cc10d6;
          transform: translateY(-1px);
        }

        .responsive-btn:active {
          background-color: #9D0FA4;
          transform: scale(0.97);
        }

        @media (max-width: 600px) {
          .responsive-btn {
            width: 100%;
            font-size: 18px;
            padding: 12px 0;
          }
        }
      `}</style>

      <div className="wd-page-wrapper website-wrapper">
        {/* Header Section (Simplified - original HTML contains complex WordPress/Elementor header) */}
        

        <div className="wd-page-content main-page-wrapper">
          <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
            <div className="container">
              <h1 className="entry-title title">Gallery</h1>
              <nav className="wd-breadcrumbs">
                <span typeof="v:Breadcrumb">
                  <a href="%PUBLIC_URL%/index.html" rel="v:url" property="v:title">Home</a>
                </span>
                <span className="wd-delimiter"></span>
                <span className="wd-last">Gallery</span>
              </nav>
            </div>
          </div>

          <main className="wd-content-layout content-layout-wrapper container" role="main">
            <div className="wd-content-area site-content">
              <article id="post-209" className="entry-content post-209 page type-page status-publish hentry">
                <div data-elementor-type="wp-page" data-elementor-id="209" className="elementor elementor-209">
                  <div className="wd-negative-gap elementor-element elementor-element-bdb4cbe e-flex e-con-boxed e-con e-parent e-lazyloaded" data-id="bdb4cbe" data-element_type="container">
                    <div className="e-con-inner">
                      {/* Image Gallery Widget - this is a static representation, dynamic galleries often involve JS */}
                      <div className="elementor-element elementor-element-f1174f8 wd-width-100 elementor-widget elementor-widget-wd_images_gallery" data-id="f1174f8" data-element_type="widget" data-widget_type="wd_images_gallery.default">
                        <div className="elementor-widget-container">
                          <div className="wd-images-gallery photoswipe-images" style={{ '--wd-align-items': 'center', '--wd-justify-content': 'center' }}>
                            <div className="wd-grid-g" style={{ '--wd-col-lg': 3, '--wd-col-md': 3, '--wd-col-sm': 1, '--wd-gap-lg': '0px' }}>
                              {/* Gallery Item 1 */}
                              <div className="wd-gallery-item wd-col">
                                <a href="" data-width="2250" data-height="1200" data-index="1" data-elementor-open-lightbox="no">
                                  <img fetchPriority="high" decoding="async" width="2250" height="1200" src="images/Slpe-1.png" className="attachment-full size-full" alt="Slpe (1)"
                                    srcSet="images/Slpe-1.png 2250w, images/Slpe-1-300x160.png 300w, images/Slpe-1-1024x546.png 1024w, images/Slpe-1-768x410.png 768w, images/Slpe-1-1536x819.png 1536w, images/Slpe-1-2048x1092.png 2048w"
                                    sizes="(max-width: 2250px) 100vw, 2250px" />
                                </a>
                              </div>
                              {/* Gallery Item 2 */}
                              <div className="wd-gallery-item wd-col">
                                <a href="" data-width="2250" data-height="1200" data-index="2" data-elementor-open-lightbox="no">
                                  <img decoding="async" width="2250" height="1200" src="images/Slpe-2.png" className="attachment-full size-full" alt="Slpe (2)"
                                    srcSet="images/Slpe-2.png 2250w, images/Slpe-2-300x160.png 300w, images/Slpe-2-1024x546.png 1024w, images/Slpe-2-768x410.png 768w" />
                                </a>
                              </div>
                              <div className="wd-gallery-item wd-col">
															<a
																href=""
																data-width="1901" data-height="700" data-index="3"
																data-elementor-open-lightbox="no">

																<img decoding="async" width="1901" height="700"
																	src="images/Untitled-design-86.png"
																	className="attachment-full size-full" alt="Untitled design (86)"
																	srcSet="images/Untitled-design-86.png 1901w, images/Untitled-design-86-300x110.png 300w, images/Untitled-design-86-1024x377.png 1024w, images/Untitled-design-86-768x283.png 768w, images/Untitled-design-86-1536x566.png 1536w"
																	sizes="(max-width: 1901px) 100vw, 1901px"/>
															</a>
														</div>
														<div className="wd-gallery-item wd-col">
															<a
																href=""
																data-width="785" data-height="524" data-index="4"
																data-elementor-open-lightbox="no">

																<img loading="lazy" decoding="async" width="785" height="524"
																	src="images/w-education-school-img.jpg.webp"
																	className="attachment-full size-full"
																	alt="w-education-school-img.jpg"
																	srcSet="images/w-education-school-img.jpg.webp 785w, images/w-education-school-img.jpg-300x200.webp 300w, images/w-education-school-img.jpg-768x513.webp 768w"
																	sizes="(max-width: 785px) 100vw, 785px"/>
															</a>
														</div>
                              {/* Add more gallery items as needed, following the pattern */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </main>
        </div>

        {/* Footer Section (Simplified - original HTML contains complex WordPress/Elementor footer) */}
        {/* You would typically have a separate Footer component */}
      </div>
    </>
  );
};

export default GalleryPage;